// external

// internal
import htmlSerializer from './src/htmlSerializer';
import replace from './src/replace';
import { replacePrismicObject } from './src/replace';
import getHrefLangs from './src/getHrefLangs';
import queryAll from './src/queryAll';
import Format from './src/format';
import escapeHtml from './src/escapeHtml';

function app ({ app, redirect }, inject) {

    // Translate helper
    const translate = (key, fallback) => {
        if (! app.store.state || ! app.store.state.translations) {
            return fallback;
        }

        return app.store.state.translations[key] || fallback;
    };
    app.context.$translate = translate;
    inject('translate', translate);

    // Settings helper
    const settings = (key) => {
        if (! app.store.state || ! app.store.state.settings) {
            return null;
        }

        return app.store.state.settings[key];
    };
    app.context.$settings = settings;
    inject('settings', settings);
    
    // Format helper
    app.context.$format = Format;
    inject('format', Format);

    if (process && process.client) {
        window.addEventListener('click', event => {
            try {
                if (! event.target.matches('a[data-nuxt-link]')) {
                    return;
                }
                event.preventDefault();
                redirect(event.target.pathname);
            }
            catch (error) {
                return;
            }
        }, false);
    }
}

export default app;
export { htmlSerializer, replace, getHrefLangs, queryAll, Format, replacePrismicObject, escapeHtml };